
import { defineComponent } from "vue";
import SectionDivisor from "../SectionDivisor.vue";

export default defineComponent({
  components: { SectionDivisor }
});
